// extracted by mini-css-extract-plugin
export default {"input":"Lda-z","button":"Mda-z","selected":"Nda-z","unavailable":"Oda-z","oos":"Pda-z","image":"Qda-z","paperCutDisabledOverlay":"Rda-z"};